/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMenuAvailabilityRequest
 */
export interface UpdateMenuAvailabilityRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMenuAvailabilityRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateMenuAvailabilityRequest
     */
    until?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMenuAvailabilityRequest
     */
    untilClosure?: boolean;
}

/**
 * Check if a given object implements the UpdateMenuAvailabilityRequest interface.
 */
export function instanceOfUpdateMenuAvailabilityRequest(value: object): value is UpdateMenuAvailabilityRequest {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateMenuAvailabilityRequestFromJSON(json: any): UpdateMenuAvailabilityRequest {
    return UpdateMenuAvailabilityRequestFromJSONTyped(json, false);
}

export function UpdateMenuAvailabilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMenuAvailabilityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'until': json['until'] == null ? undefined : json['until'],
        'untilClosure': json['untilClosure'] == null ? undefined : json['untilClosure'],
    };
}

export function UpdateMenuAvailabilityRequestToJSON(json: any): UpdateMenuAvailabilityRequest {
    return UpdateMenuAvailabilityRequestToJSONTyped(json, false);
}

export function UpdateMenuAvailabilityRequestToJSONTyped(value?: UpdateMenuAvailabilityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'until': value['until'],
        'untilClosure': value['untilClosure'],
    };
}

